export default __webpack_public_path__ + "static/media/ic_user_black.39928a6b.svg";